import { Grid, GridProps } from '@mantine/core';

export type IGridProps = GridProps;

/**
 * Mantine's `Grid` with the project defaults.
 *
 * `overflow` is deliberately left at Mantine's `visible`. This used to default
 * to `hidden` to hide the horizontal overflow that Mantine <= v7's Grid caused
 * with its negative-margin inner wrapper. v9's Grid lays the columns out with
 * flex `gap` instead, so there is nothing left to hide — and clipping the root
 * cut off anything a column painted outside its box, most visibly the
 * `DocumentCard` `shadow` variant's 12px glow (ENG-1130).
 */
export function ZorroGrid(props: IGridProps) {
  return <Grid {...props} />;
}

ZorroGrid.Col = Grid.Col;
